import { ScrollTrigger } from 'gsap/ScrollTrigger';

const PAGE_READY_EVENT = 'stablevine:page-ready';
const BEFORE_NAVIGATE_EVENT = 'stablevine:before-navigate';

function onDomReady(callback) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, { once: true });
  } else {
    callback();
  }
}

function shouldWaitForTransition() {
  const overlay = document.querySelector('.page-transition-overlay');
  return Boolean(overlay && !overlay.classList.contains('is-hidden') && !window.stablevinePageReady);
}

function refreshScrollTriggers() {
  if (ScrollTrigger && typeof ScrollTrigger.refresh === 'function') {
    requestAnimationFrame(() => {
      ScrollTrigger.refresh(true);
    });
  }
}

export function runWhenPageReady(callback) {
  onDomReady(() => {
    if (!shouldWaitForTransition()) {
      callback();
      return;
    }

    const run = () => {
      callback();
      refreshScrollTriggers();
    };

    document.addEventListener(PAGE_READY_EVENT, run, { once: true });

    window.addEventListener('load', () => {
      setTimeout(() => {
        const isTransitioning = document.documentElement.classList.contains('stablevine-page-transitioning');
        if (!window.stablevinePageReady && !isTransitioning) {
          markPageReady('fallback');
        }
      }, 7000);
    }, { once: true });
  });
}

export function markPageReady(source = 'manual') {
  if (window.stablevinePageReady) {
    return;
  }

  window.stablevinePageReady = true;
  document.documentElement.classList.add('stablevine-page-ready');
  document.documentElement.classList.remove('stablevine-page-transitioning');

  document.dispatchEvent(new CustomEvent(PAGE_READY_EVENT, {
    detail: { source }
  }));

  refreshScrollTriggers();
}

export function markPageTransitioning(source = 'manual') {
  window.stablevinePageReady = false;
  document.documentElement.classList.remove('stablevine-page-ready');
  document.documentElement.classList.add('stablevine-page-transitioning');

  document.dispatchEvent(new CustomEvent(BEFORE_NAVIGATE_EVENT, {
    detail: { source }
  }));
}

export { PAGE_READY_EVENT, BEFORE_NAVIGATE_EVENT };
